import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const invalidateStaffsDocuments = (fileId: number) => {
  return restApiClient.url(constructApiUrl(API.staffs.invalidate.url, { id: fileId })).post()
}
